import { getTitleWithParentheses } from '../string';
import { dataSchema2MarkDown } from "../../../lib/utils/dataSchema/generateDataSchemaMarkdown";
export function generateMethodDocumentMarkdown(m, options = {}) {
  var _m$arguments;
  if (!m) return '';
  const sourceLines = [];
  if (!options.omitTitles) {
    sourceLines.push(`## ${getTitleWithParentheses(m.id, m.title)}`);
  }
  if (m.description) sourceLines.push(m.description);
  if ((_m$arguments = m.arguments) !== null && _m$arguments !== void 0 && _m$arguments.length) {
    sourceLines.push('### 参数');
    m.arguments.forEach(arg => {
      const txtBase = [];
      // 如果定了type和id 尝试转到tsInterface上
      const tsMarkdown = methodsArg2MarkDown(arg);
      if (tsMarkdown) {
        txtBase.push(tsMarkdown);
      } else {
        var _arg$id;
        const txt = [`**${getTitleWithParentheses(String((_arg$id = arg.id) !== null && _arg$id !== void 0 ? _arg$id : ''), arg.title)}**`, arg.type !== 'any' && `**类型 - ${arg.type}**`, arg.required === false && '可选', arg.description].filter(Boolean);
        txtBase.push(...txt);
      }
      const txt = txtBase.filter(Boolean).join('\n\n');
      sourceLines.push(txt.trim().replace(/^/gm, '   ').replace(/^   /, '1. '));
    });
    // } else {
    //   sourceLines.push('### 参数', '*无*');
  }
  if (m.returnValue) {
    sourceLines.push('### 输出');
    if (m.returnValue.type !== 'any') sourceLines.push(`*类型：${m.returnValue.type}*`);
    if (m.returnValue.id || m.returnValue.title) {
      var _m$returnValue$id;
      sourceLines.push(getTitleWithParentheses(String((_m$returnValue$id = m.returnValue.id) !== null && _m$returnValue$id !== void 0 ? _m$returnValue$id : ''), m.returnValue.title));
    }
    if (m.returnValue.description) sourceLines.push(m.returnValue.description);
    // } else {
    //   sourceLines.push('### 输出', '*无*');
  }
  if (!options.omitTitles && sourceLines.length <= 1) {
    // 就一个title 可以直接隐藏文档弹窗了
    return '';
  }
  const markdownSource = sourceLines.join('\n\n');
  return markdownSource;
}
/** 返回多行markdown 来生成对arguments的备注信息 */
function methodsArg2MarkDown(ds) {
  if (!ds) return undefined;
  if (ds.id && ds.type) {
    return dataSchema2MarkDown(ds, ds.id, {
      expand: true
    });
  }
  return undefined;
}
//# sourceMappingURL=generateMethodDocumentMarkdown.js.map
